import { render, staticRenderFns } from "./estAllocation.vue?vue&type=template&id=f134daf6&"
import script from "./estAllocation.vue?vue&type=script&lang=js&"
export * from "./estAllocation.vue?vue&type=script&lang=js&"
import style0 from "./estAllocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports